import { signal } from "@preact/signals-react"

export const isOpenCreateSftpUserModal = signal(false)
export const sftpCreatedPassword = signal(null)